import { createActionThunk } from 'redux-thunk-actions'
import { createAction, handleActions } from 'redux-actions'
import debounceAction from 'debounce-action'
import _ from 'lodash'

import api from 'core/api'
import { prepare_coin_number, prepare_currency_number } from 'core/utils'
import parametersSelector from 'selectors/parameters'

const getType = type => `@calculations/estimates/${type}`

const setPreviousCurrenciesValue = createAction(getType('currencies/SET_PREVIOUS'))

export const getCurrenciesThunk = createActionThunk(
  getType('currencies/FETCH'),
  api('/calculations/estimates/currencies')
)

export const getCurrenciesThunkSmart = (value, force) => (dispatch, getState) => {
  const { previousCurrenciesValue } = _.get(getState(), 'calculations.estimates')
  if (!force && _.isEqual(previousCurrenciesValue, value)) return Promise.resolve()
  dispatch(setPreviousCurrenciesValue(value))
  return dispatch(getCurrenciesThunk(value))
}

export const getCurrencies = (value, force) => (dispatch, getState) => {
  const parameters = parametersSelector(getState())
  const coin_amount = parseFloat(prepare_coin_number(parameters)(value))
  return dispatch(getCurrenciesThunkSmart({ coin_amount }, force))
}

export const getCurrenciesDebounced = debounceAction(getCurrencies, 300)

export const getTokensThunk = createActionThunk(
  getType('tokens/FETCH'),
  api('/calculations/estimates/tokens')
)

const setPreviousTokensValue = createAction(getType('tokens/SET_PREVIOUS'))

export const getTokensThunkSmart = (value, force) => (dispatch, getState) => {
  const { previousTokensValue } = _.get(getState(), 'calculations.estimates')
  if (!force && _.isEqual(previousTokensValue, value)) return Promise.resolve()
  dispatch(setPreviousTokensValue(value))
  return dispatch(getTokensThunk(value))
}

export const getTokens = (value, force) => (dispatch, getState) => {
  const parameters = parametersSelector(getState())
  const coin_price = parseFloat(prepare_currency_number(parameters)(value))
  dispatch(getTokensThunkSmart({ coin_price }, force))
}

export const getTokensDebounced = debounceAction(getTokens, 300)

export const reset = createAction(getType('RESET'))

const initialState = { json: {}, loading: false }

export default handleActions(
  {
    [getCurrenciesThunk.START]: state => ({ ...state, loading: true }),
    [getCurrenciesThunk.SUCCEEDED]: (state, { payload }) => ({ ...state, ...payload }),
    [getCurrenciesThunk.ENDED]: (state, { payload }) => ({ ...state, loading: false }),
    [setPreviousCurrenciesValue]: (state, { payload }) => ({
      ...state,
      previousCurrenciesValue: payload
    }),

    [getTokensThunk.START]: state => ({ ...state, loading: true }),
    [getTokensThunk.SUCCEEDED]: (state, { payload }) => ({ ...state, ...payload }),
    [getTokensThunk.ENDED]: state => ({ ...state, loading: false }),
    [setPreviousTokensValue]: (state, { payload }) => ({ ...state, previousTokensValue: payload }),

    [reset]: () => initialState
  },
  initialState
)



// WEBPACK FOOTER //
// ./src/modules/calculations/estimates.js